module.exports = __webpack_public_path__ + "static/media/Map.49f5ce04.png";